import { render, staticRenderFns } from "./MyQuoteDetails.vue?vue&type=template&id=1797c96c&scoped=true&"
import script from "./MyQuoteDetails.vue?vue&type=script&lang=js&"
export * from "./MyQuoteDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyQuoteDetails.vue?vue&type=style&index=0&id=1797c96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1797c96c",
  null
  
)

export default component.exports